import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "line__item" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center","border":"1px solid grey","height":"100%","background":"lime"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"margin":"10px"} }, "Loading graph....", -1)
const _hoisted_5 = { class: "line__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_grafana_component = _resolveComponent("grafana-component")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_grafana_select_component = _resolveComponent("grafana-select-component")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_buy_order_form_component = _resolveComponent("buy-order-form-component")!
  const _component_order_books_component = _resolveComponent("order-books-component")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_list_orders_component = _resolveComponent("list-orders-component")!
  const _component_list_trades_component = _resolveComponent("list-trades-component")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, {
                class: "section__padding",
                style: {"overflow-y":"hidden"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { style: {"min-width":"900px","height":"40vh"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_grafana_select_component, null, {
                          default: _withCtx(({ graphSrc, args }) => [
                            _createElementVNode("div", _hoisted_2, [
                              (graphSrc && args)
                                ? (_openBlock(), _createBlock(_component_grafana_component, {
                                    key: 0,
                                    src: graphSrc,
                                    args: [...args]
                                  }, null, 8, ["src", "args"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createVNode(_component_ion_spinner),
                                    _hoisted_4
                                  ]))
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { style: {"min-width":"900px","height":"40vh"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_buy_order_form_component, {
                          onFetch: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ChangeDates($event)))
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_order_books_component)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_list_orders_component)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_list_trades_component)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}